/* eslint-disable @typescript-eslint/no-unused-vars */
import * as X from "@/ui";

import HeroDesktopImage from "@/assets/bucket/retailer-home-hero-desktop.png";
import HeroMobileImage from "@/assets/bucket/retailer-home-hero-mobile.png";
import { useRetailerHomePage } from "@/providers/strapi/content/types/singleTypes/retailer-home-page";
import ReactMarkdown from "react-markdown";
import clsx from "clsx";


export function HeroSection(_props: X.PageProps) {
  // const tr = X.useTranslator();
  const hero = useRetailerHomePage('hero');
  return (
    <section className="relative w-full">
      {/* <h1 className="xl:text-center text-[35px] xl:text-[64px] [&_strong]:font-semibold mx-mobile-margin xl:max-w-[1000px] xl:mx-auto leading-tight">
        {tr({
          en: <>Serve international customers. <strong>We take care of the VAT!</strong></>,
          fr: <>La détaxe simplifiée, pour vous et <strong>vos clients internationaux</strong></>,
        })}
      </h1> */}

      <ReactMarkdown
        components={{
          p: ({ ...props }) => <h1 {...props} className="xl:text-center text-[35px] xl:text-[64px] [&_strong]:font-semibold mx-mobile-margin xl:max-w-[1000px] xl:mx-auto leading-tight" />
        }}
      >
        {hero.tagLine}
      </ReactMarkdown>
      <div className="my-10 mx-mobile-margin xl:max-w-4xl xl:mx-auto text-[16px] xl:text-[24px] leading-tight xl:text-center flex flex-col gap-2">
        {/* TODO Change this to markdown*/}
        <ReactMarkdown>
          {hero.content}
        </ReactMarkdown>
        {/* <p>
          {tr({
            en: `Zapptax Retail gives you a smooth, flexible, and accessible way to offer tax-free shopping — no matter your industry or store size.`,
            fr: `Avec Zapptax Retail, offrez une expérience de détaxe fluide, flexible et accessible, quel que soit votre secteur ou votre chiffre d’affaires.`,
          })}
        </p>
        <p>
          {tr({
            en: `Let’s simplify VAT refunds together and build loyalty with your most demanding international shoppers.`,
            fr: `Ensemble, facilitons le shopping détaxé et fidélisons une clientèle internationale exigeante.`,
          })}
        </p> */}
      </div>

      <div className="my-10 xl:max-w-content xl:mx-auto">
        <div className="flex flex-row justify-center gap-4 translate-y-1/2 relative z-10">
          <X.Button
            primary desktopLg
            href="/retail/become-partner"
            label={hero.becomePartnerCta}
          // label={tr({
          //   en: "Become a partner",
          //   fr: "Devenir partenaire",
          // })}
          />
          <X.Button
            tertiary desktopLg

            //exitHref={X.links.login}
            disabled
            tooltip={"Coming soon"
              //   tr({
              //   en: "Coming soon",
              //   fr: "Bientôt",
              // })
            }

            className="bg-white"
            label={hero.loginCta}
          // label={tr({
          //   en: "Sign in",
          //   fr: "Se connecter",
          // })}
          />
        </div>

        {/* <X.Image
          src={HeroDesktopImage}
          alt="Retailers"
          className={X.clsx(X.desktopOnly("block"), "xl:w-full h-auto rounded-xl")}
          priority
        /> */}
        <div className="relative w-full min-h-[330px] xl:min-h-[475px] h-full z-0">
          <X.Image
            src={hero.picture.url}
            // width={hero.picture.width}
            // height={hero.picture.height}
            fill
            unoptimized
            alt="Retailers"
            // className={X.clsx("ml-4 xl:ml-0 xl:w-full min-h-[320px] xl:h-auto rounded-l-2xl xl:rounded-2xl")}
            className={clsx([
              'ml-4 w-full ',
              'xl:ml-0',
              'object-cover object-[20%_50%]',
              'rounded-2xl'
            ])}
            priority
          />
        </div>
        {/* <X.Image
          src={hero.picture.url}
          width={hero.picture.width}
          height={hero.picture.height}
          unoptimized
          alt="Retailers"
          className={X.clsx("ml-4 xl:ml-0 xl:w-full min-h-[320px] xl:h-auto rounded-l-2xl xl:rounded-2xl")}
          priority
        /> */}
        {/* <X.Image
          src={HeroMobileImage}
          alt="Retailers"
          className={X.clsx(X.mobileOnly(), "ml-4 w-full h-auto rounded-l-xl")}
          priority
        /> */}
      </div>
    </section>
  );
}
